import { Column, Row } from '@components/LinearLayout';
import { P, PSmall, PSmallBold } from '@components/Typography';

import styled from 'styled-components';

export const AgendaItemsRoot = styled.section`
  display: grid;
  grid-template-columns: auto 1fr;
  margin-bottom: 5rem;
  grid-gap: 2rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column;
    padding: 0 2rem;
    grid-gap: 1.5rem;
  }
`;

export const SessionDetailsSection = styled(Column)<{
  $color: string;
  $minimal?: boolean;
}>`
  background-color: ${({ $color }) => $color};
  width: 16rem;
  padding: 3rem 0;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  align-items: center;
  gap: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top: 0;
    gap: 0;
  }

  ${({ $minimal }) =>
    $minimal &&
    `
      padding: 0.95rem 1rem;
      width: auto;
      min-height: unset;
      height: fit-content;
      align-items: flex-start;
      gap: 0.5rem;
      
    `}
`;

export const SessionDetailsText = styled(PSmallBold)`
  color: ${({ theme }) => theme.color.white};
  text-align: center;
`;

export const SessionDetailsItem = styled.div<{
  $minimal?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 2.5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    flex: 0 1 50%;
    padding: 2.5rem;
  }

  ${({ $minimal, theme }) =>
    $minimal &&
    `
      @media only screen and (max-width: ${theme.breakpoint.width480}) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 1rem;
        padding: 0.5rem 1rem;
        padding-top: 1.5rem;
      }
    `}
`;

export const SessionDescription = styled(Column)`
  gap: 3rem;
`;

export const SessionTitleWrapper = styled.div<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  padding: 3rem 2.5rem;
`;

export const SessionTitle = styled(P)`
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  line-height: ${({ theme }) => theme.lineHeight.height150};
`;

export const SessionDescriptionText = styled(PSmall)`
  height: auto;
  padding: 1.5rem;
  color: ${({ theme }) => theme.color.mobilityGrey};
`;

export const Tags = styled(Row)`
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 1.5rem;
`;

export const Tag = styled.div<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.borderRadius.radius20};
  font-size: ${({ theme }) => theme.fontSize.size14};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  padding: 0.5rem 1.5rem;
  transition: background-color 600ms cubic-bezier(0.4, 0.47, 0.13, 0.88);
`;

export const RightSideBox = styled.div<{ $minimal?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ $minimal, theme }) =>
    $minimal &&
    `
      background-color: #FFFFFF;    
      border-radius: ${theme.borderRadius.radius10};
      
    `}
`;

export const SpeakersWrapper = styled.div`
  grid-gap: 4.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(38rem, 1fr));
  padding: 1.5rem;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    display: flex;
    flex-direction: column;
  }
`;

export const EventName = styled.div<{ $backgroundColor: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  text-align: center;
  color: ${({ theme }) => theme.color.white};
  padding: 2.5rem;
  word-break: break-all;
  width: 100%;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.radius10};
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.radius10};
  }
`;
